module.exports = __webpack_public_path__ + "static/media/ecgQuestion.ee985d76.mp3";